/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Material ExpandMore Icon component.
 */
export const MaterialExpandMoreIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MaterialExpandMoreIcon' size={iconSize} color={iconColor as any} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M20 8.867L18.133 7 12 13.133 5.867 7 4 8.867l8 8 8-8z'
          fillRule='evenodd'
          clipRule='evenodd'
          fill={iconColor} />
      </svg>
    )} />
  );
};
